import { EventSourcePolyfill } from 'event-source-polyfill'
import config from '../../../../../../config'

const merchantEventServiceUrl = config.merchantEventServiceUrl

const eventStreamOptions = () => ({
  headers: {
    Accept: 'text/event-stream',
  },
})

export class MerchantEventStream {
  constructor(callback, id) {
    const options = eventStreamOptions()
    this.source = new EventSourcePolyfill(
      `${merchantEventServiceUrl}/events/stream/${id}`,
      options,
    )

    this.source.onmessage = message => {
      if (message && message.data) {
        const json = JSON.parse(message.data)
        callback(json)
      }
    }

    this.source.onerror = error => {
      // eslint-disable-next-line no-console
      console.log('Error: ', error)
    }
  }

  stop() {
    this.source.close()
  }
}
